import { styled } from '@mui/material/styles';
import { Theme } from '@mui/material/styles';

import { AppBar, IconButton, Container } from '@mui/material';

export const HeaderWrapper = styled('div')`
  display: flex;
`;

export const AppBarStyled = styled(AppBar)(({ theme }: { theme: Theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

export const NavRight = styled('div')(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginRight: theme.spacing(2),
}));

export const NavLeft = styled('div')(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginLeft: theme.spacing(2),
}));

export const Toolbar = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: '45px',
}));

export const ProfileEmail = styled('div')(({ theme }: { theme: Theme }) => ({
  marginRight: theme.spacing(1),
  color: theme.palette.primary.contrastText,
}));

export const ProfileLocation = styled('div')(({ theme }: { theme: Theme }) => ({
  marginRight: theme.spacing(5),
  color: theme.palette.primary.contrastText,
}));

export const Profile = styled('div')(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  cursor: 'pointer',
  color: theme.palette.primary.contrastText,
  marginLeft: '16px',
}));

export const SectionDesktop = styled('div')(({ theme }: { theme: Theme }) => ({
  color: theme.palette.primary.contrastText,
  display: 'flex',
}));

export const LeftNavIcon = styled(IconButton)(
  ({ theme }: { theme: Theme }) => ({
    marginRight: theme.spacing(2),
    color: 'inherit',
    edge: 'start',
  }),
);
